import { REGIONS, type Region } from '../region';

const UK_BANNER_TEXT =
  'Cookies help us deliver the best experience on our website. By using our website, you agree to the use of cookies.';

const COOKIE_BANNER_TEXT: Record<Region, string> = {
  [REGIONS.UK]: UK_BANNER_TEXT,
  [REGIONS.US]: UK_BANNER_TEXT,
  [REGIONS.EU]:
    'We use cookies to enhance your experience on our website. Under EU regulations, we need your explicit consent before placing non-essential cookies on your device.',
};

export default COOKIE_BANNER_TEXT;
